<!--
  Usage:

  <Bar                 fill='20'></Bar>
  <Bar type='progress' fill='20'></Bar>
  <Bar type='mini'     fill='20'></Bar>

-->

<template>
  <div class="Bar"
      :class="`Bar--${type}`"
      :style="`width:${width}`">
    <div class="Bar-fill" :style="progressStyle"></div>
  </div>
</template>

<script>
  import { interpolateColour,
           inArray,
           inlineCss,
           darkenColour } from '@/legacy/lib//util';

  export default {
    props: {
      type: {
        type: String,

        validator: function (value) {
          return inArray (value, [
            'progress',
            'mini'
          ])
        },

        default: 'mini'
      },

      fill: {
        type: Number,
        default: 0
      },

      colour: {
        type: String
      },

      width: {
        type: String,
        default: "100%"
      },

      invert: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      progressStyle: function () {
        return inlineCss ({
          'width':      `${this.fill}%`,
          'background': `linear-gradient(to right,${this.backgroundFrom} 0,${this.backgroundTo} 100%)`
        });
      },

      backgroundFrom: function () {
        return darkenColour (this.backgroundTo, 3);
      },

      backgroundTo: function () {
        return this.colour || interpolateColour (this.fill, null, null, this.invert);
      }
    }
  }
</script>

<style lang="scss" scoped>
  $bar-progress-height: 25px;
  $bar-mini-height: 4px;

  .Bar {
    background-color: #181818;
    border: 1px solid shade($w3s-white, 30);

    box-shadow: inset 0 0 16px #000;

    display: flex;
    flex-direction: row;
    margin: 0 auto;
    opacity: 0.9;

    /** **/

    &--mini {
      bottom: 0;
      left: 5px;
      right: 5px;
      position: absolute;

      height: $bar-mini-height;

      &__fill {
        height: $bar-mini-height - 1;
      }
    }

    &--progress {
      height: $bar-progress-height;

      &__fill {
        height: $bar-progress-height - 1;
      }
    }

    /** **/

    &-fill {
      background-color: shade($w3s-yellow, 60);
      transition: all .5s;
    }
  }
</style>